import React from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Flex,
  Box,
} from '@chakra-ui/react';
import { ModalType } from 'constants/common';
import { toast } from 'components/Toast';
import { useDeleteDomainAccess } from 'services/system';

export default function DeleteSourceAccessModal({ textDetail, isOpen, onClose, refetch }) {
  const deleteDomainAccessMutation = useDeleteDomainAccess();

  const onSubmit = () => {
    if (textDetail?._id) {
      deleteDomainAccessMutation.mutate(
        {
          id: textDetail?._id,
        },
        {
          onSuccess: () => {
            toast.showMessageSuccess('Xoá domain thành công');
            onClose(ModalType.Delete);
            refetch();
          },
        }
      );
    }
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      onClose={() => {
        onClose(ModalType.Delete);
      }}
      isOpen={isOpen}
      isCentered
      size="2xl"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader textTransform="uppercase"></AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>
          <Box textAlign="center">{`Bạn có chắc chắn muốn xoá domain này?`}</Box>
        </AlertDialogBody>
        <AlertDialogFooter justifyContent="center">
          <Flex gap="12px">
            <Button
              onClick={() => {
                onClose(ModalType.Delete);
              }}
            >
              Không
            </Button>
            <Button colorScheme="blue" isLoading={deleteDomainAccessMutation.isPending} onClick={onSubmit}>
              OK
            </Button>
          </Flex>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
